import { gql } from '@apollo/client';
import config from '../config';

export const READ_MESSAGE = gql`
  mutation readMessage($messageBoardId: String!) {
    readMessage(messageBoardId: $messageBoardId) {
      OwnerMessages
      TherapistMessages
    }
  }
`;

export const SEND_MESSAGE = gql`
  mutation SendMessageMutation($message: String!, $messageBoardId: String!) {
    sendMessage(input: { message: $message, messageBoardId: $messageBoardId }) {
      to
      message
      from
      date
      MessageBoardId
    }
  }
`;

export const UPDATE_MESSAGE_BOARD = config.root.includes('ofpw8yar0c')
  ? gql`
      mutation UpdateMessageBoardDev(
        $input: UpdateMessageBoardDevInput!
        $EmailAddress: String!
      ) {
        updateMessageBoardDev(input: $input, EmailAddress: $EmailAddress) {
          Avatar
          GroupId
          Id
          Owner
          Therapist
          FirstName
          LastName
          OwnerMessages
          OwnerRead
          PTFirstName
          PTLastName
          LastMessageDate
          TherapistMessages
          TherapistRead
          Messages {
            date
            from
            message
            to
          }
        }
      }
    `
  : gql`
      mutation UpdateMessageBoardProd(
        $input: UpdateMessageBoardDevInput!
        $EmailAddress: String!
      ) {
        updateMessageBoardProd(input: $input, EmailAddress: $EmailAddress) {
          Avatar
          GroupId
          Id
          Owner
          Therapist
          FirstName
          LastName
          OwnerMessages
          OwnerRead
          PTFirstName
          PTLastName
          LastMessageDate
          TherapistMessages
          TherapistRead
          Messages {
            date
            from
            message
            to
          }
        }
      }
    `;
